import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getWebsiteArticle, getLogoList } from "@/services";

export const fetchWebsiteArticle = createAsyncThunk("fetchWebsiteArticle", async (payload) => {
	const res = await getWebsiteArticle(payload);
	return res;
});

export const fetchLogoList = createAsyncThunk("fetchLogoList", async (payload) => {
	const res = await getLogoList(payload);
	return res;
});

const HomeSlice = createSlice({
	name: "home",
	initialState: {},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchWebsiteArticle.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			})
			.addCase(fetchLogoList.rejected, (_, payload) => {
				throw new Error(payload.error.message);
			});
	},
});

// export const { changeUserInfo } = LoginSlice.actions;

export default HomeSlice.reducer;
